import { render, staticRenderFns } from "./ChatSources.vue?vue&type=template&id=6f8062f8&scoped=true&"
import script from "./ChatSources.vue?vue&type=script&lang=js&"
export * from "./ChatSources.vue?vue&type=script&lang=js&"
import style0 from "./ChatSources.vue?vue&type=style&index=0&id=6f8062f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8062f8",
  null
  
)

export default component.exports